import { render, staticRenderFns } from "./VfTooltip.vue?vue&type=template&id=4a46285d&scoped=true&"
import script from "./VfTooltip.vue?vue&type=script&lang=js&"
export * from "./VfTooltip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a46285d",
  null
  
)

export default component.exports